import Layout from './components/layout/Layout';
import Home from './pages/Home.tsx';
import About from './pages/About';
import Map from './pages/Map';
import WebVR from './pages/WebVR';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/map" element={
            <div className="h-[calc(100vh-8rem)] w-full relative">
              <Map />
            </div>
          } />
          <Route path="/webvr" element={<WebVR />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
